// client/src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';

// Import your page components
import Character from './pages/Character';
import Admin from './pages/admin';

// A simple Not Found page
const NotFound = () => (
  <div style={{ textAlign: 'center', padding: '50px' }}>
    <h1>404 - Page Not Found</h1>
    <p>The page you are looking for does not exist.</p>
    <Link to="/">Go back to Home</Link>
  </div>
);

function App() {
  return (
    <Router>
      <div>
        <main>
          <Routes>
            {/* Route for the Home Page */}
            <Route path="/" element={<Character />} />

            {/* Route for the Admin Panel */}
            <Route path="/admin" element={<Admin />} />

            {/* Catch-all route for 404 Not Found */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;